import React, { createContext, useContext, useState, useEffect } from "react";

const LocaleContext = createContext(null);

const defaultTranslations = {
  en: {
    "footer.copyright": "Copyright © 2025 Hsmail. All Rights Reserved.",
    "lang.chinese": "中文",
    "lang.english": "English",
    // 侧边栏
    "sidebar.dashboard": "Dashboard",
    "sidebar.users": "Users",
    "sidebar.emails": "Emails",
    "sidebar.proxy": "Proxy",
    "sidebar.files": "Files",
    "sidebar.whitelist": "Whitelist",
    // Landing Page - Management Modules
    "email.dashboard.title": "Dashboard",
    "email.dashboard.desc": "Data Overview & Analytics",
    "email.dashboard.feat1": "Sending Statistics",
    "email.dashboard.feat2": "Trend Charts",
    "email.dashboard.feat3": "Real-time Monitoring",
    "email.emails.title": "Email Management",
    "email.emails.desc": "Email Sending & List Management",
    "email.emails.feat1": "Email Sending",
    "email.emails.feat2": "Email List View",
    "email.emails.feat3": "Email Search & Filter",
    "email.users.title": "User Management",
    "email.users.desc": "Users & Permission Management",
    "email.users.feat1": "User Account Management",
    "email.users.feat2": "Role Permission Assignment",
    "email.users.feat3": "User Behavior Records",
    "email.proxy.title": "Proxy Management",
    "email.proxy.desc": "Proxy Server Configuration",
    "email.proxy.feat1": "Proxy Server List",
    "email.proxy.feat2": "IP Hide & Rotate",
    "email.proxy.feat3": "Connection Status Monitor",
    "email.files.title": "Template Management",
    "email.files.desc": "Email Template Creation & Management",
    "email.files.feat1": "Template Creation & Editing",
    "email.files.feat2": "Template Preview & Send",
    "email.files.feat3": "Template Status Control",
    "email.whitelist.title": "Whitelist",
    "email.whitelist.desc": "Trusted Email Address Management",
    "email.whitelist.feat1": "Email Address Whitelist",
    "email.whitelist.feat2": "Domain Whitelist",
    "email.whitelist.feat3": "Quick Add Management",
    // Analytics Section
    "email.analytics.badge": "Analytics",
    "email.analytics.title1": "Email Statistics",
    "email.analytics.title2": "Visual Analytics",
    "email.analytics.description":
      "Monitor email sending data in real-time and understand delivery status and system performance",
    "email.analytics.feat1": "Email sending success rate",
    "email.analytics.feat2": "Sending trend charts",
    "email.analytics.feat3": "Bounce & failure analysis",
    "email.analytics.feat4": "Real-time sending status",
    "email.analytics.explore": "View Details",
    // Features Section
    "email.features.subtitle": "Core Features",
    "email.features.title": "Professional Email Management",
    "email.features.description":
      "All-in-one email management solution for enterprise email sending needs",
    "email.features.mail.title": "Professional Email Sending",
    "email.features.mail.desc":
      "Support SMTP/API bulk email sending with efficient delivery service",
    "email.features.security.title": "Secure & Reliable",
    "email.features.security.desc":
      "Complete user permission system and whitelist mechanism for system security",
    "email.features.analytics.title": "Data Analytics",
    "email.features.analytics.desc":
      "Real-time email statistics, visualized delivery success rates and trends",
    "email.features.users.title": "Multi-User Management",
    "email.features.users.desc":
      "Support admin and regular user roles with flexible permission assignment",
    "email.features.files.title": "Template Management",
    "email.features.files.desc":
      "Create and manage email templates with preview and one-click sending",
    "email.features.proxy.title": "Proxy Support",
    "email.features.proxy.desc":
      "Flexible proxy server configuration to protect real IP and improve delivery success",
    // 趋势图
    "trend.title": "Trend",
    "legend.success": "Success",
    "legend.fail": "Fail",
    "legend.total": "Total",
    "main.all_users": "All Users",
    "summary.success": "Success",
    "summary.fail": "Fail",
    // 白名单
    "whitelist.add": "Add whitelist",
    "whitelist.search_placeholder": "Search here",
    "whitelist.no_items": "No whitelist items",
    "whitelist.table.url": "URL/DNS/IP",
    "whitelist.table.description": "Description",
    "whitelist.table.date": "Date",
    "whitelist.table.operation": "Operation",
    "white.modal.add": "Add Whitelist",
    "white.modal.edit": "Edit Whitelist",
    "white.modal.url_label": "URL or Address",
    "white.modal.description_label": "Description",
    "white.modal.cancel": "Cancel",
    "white.modal.save": "Save",
    "white.modal.url_required": "URL or Address is required",
    "pagination.go_to": "Go to",
    "pagination.go": "Go",
    "pagination.per_page": "{n} / page",
    "confirm.delete_whitelist.title": "Delete Whitelist",
    "confirm.delete_whitelist.description":
      "Are you sure you want to delete this whitelist item?",
    "confirm.delete": "Delete",
    "confirm.cancel": "Cancel",
    "notification.whitelist_added": "Whitelist added",
    "notification.whitelist_updated": "Whitelist updated",
    "notification.whitelist_deleted": "Whitelist deleted",
    "notification.failed_save": "Failed to save whitelist",
    "notification.failed_delete": "Failed to delete whitelist",
    "status.on": "ON",
    "status.off": "OFF",
    // Users
    "users.add": "Add user",
    "users.search_placeholder": "Search here",
    "users.no_items": "No contacts",
    "users.role.user": "User",
    "users.role.admin": "Admin",
    "users.table.account": "Account",
    "users.table.password": "Password",
    "users.table.nickname": "NickName",
    "users.table.role": "Role",
    "users.table.operation": "Operation",
    "confirm.delete_user.title": "Delete User",
    "confirm.delete_user.description":
      'Are you sure you want to delete the user "{name}"?',
    "notification.user_deleted": "User deleted successfully!",
    "notification.failed_delete_user": "Failed to delete user",
    "user.modal.add": "Add a User",
    "user.modal.save": "Save",
    "user.modal.cancel": "Cancel",
    "user.modal.account_required": "Account is required",
    "user.modal.password_required": "Password is required",
    // Files
    "files.search_placeholder": "Search by name",
    "files.add": "Add file",
    "files.no_items": "No files",
    "files.table.filename": "Filename",
    "files.table.status": "Status",
    "files.table.file_key": "File Key",
    "files.table.key": "Key",
    "files.table.content": "Content",
    "files.table.date": "Date",
    "files.table.operation": "Operation",
    "file.modal.add": "Add file",
    "file.modal.edit": "Edit file",
    "file.modal.preview": "Preview",
    "file.modal.filename_label": "File's Name",
    "file.modal.title_label": "File's Title",
    "file.modal.status_label": "Status",
    "notification.file_added": "File added",
    "notification.file_updated": "File updated",
    "notification.file_deleted": "File deleted",
    "notification.file_delete_failed": "Failed to delete file",

    // Proxy
    "proxy.search_placeholder": "Search by host",
    "proxy.add_one": "Add one proxy",
    "proxy.add_one_desc": "Add a single proxy entry",
    "proxy.add": "Add proxies",
    "proxy.no_items": "No proxies",
    "proxy.table.host": "Host",
    "proxy.table.port": "Port",
    "proxy.table.account": "Account",
    "proxy.table.password": "Password",
    "proxy.table.type": "Type",
    "proxy.table.status": "Status",
    "proxy.table.date": "Date",
    "proxy.table.operation": "Operation",
    "proxy.modal.add": "Add proxy",
    "proxy.modal.edit": "Edit proxy",
    "notification.proxy_added": "Proxy added",
    "notification.proxy_deleted": "Proxy deleted",
    "proxy.bulk.title": "Batch add proxies",
    "proxy.bulk.format_hint": "(host,port,account,password,SOCKS5)",
    // Emails
    "emails.add": "Add emails",
    "emails.add_one": "Add one email",
    "emails.add_one_desc": "Add a single email",
    "emails.add_many": "Add emails",
    "emails.add_many_desc":
      "Add multiple emails at once by manually copying and pasting information",
    "emails.bulk.title": "Batch add emails",
    "emails.bulk.format_hint":
      "(account,password,key,port,smtp,address | host,port,account,password,SOCKS5)",
    "emails.bulk.instructions": "Enter one CSV per line",
    "emails.adding": "Adding...",
    "emails.search_placeholder": "Search here",
    "emails.no_items": "No emails",
    // Filters (used in Main.js)
    "filters.title": "Filters",
    "filter.start_time": "Start Time",
    "filter.end_time": "End Time",
    "filter.order_user": "Order User",
    "filter.all": "All",
    "emails.table.mail_user": "Mail User",
    "emails.table.ip": "IP",
    "emails.table.mail_key": "Mail Key",
    "emails.table.mail_password": "Mail Password",
    "emails.table.port": "Port",
    "emails.table.smtp_server": "SMTP Server",
    "emails.table.status": "Status",
    "emails.table.date": "Date",
    "emails.table.operation": "Operation",
    "email.modal.add": "Add Email",
    "email.modal.edit": "Edit Email",
    "email.modal.mail_user_required": "Mail User is required",
    "email.modal.mail_password_required": "Mail Password is required",
    "email.modal.smtp_required": "SMTP Server is required",
    "email.modal.port_required": "Port is required",
    "email.modal.port_number": "Port must be a number",
    "confirm.delete_proxy": "Delete Proxy",
    "confirm.delete_proxy.description":
      "Are you sure you want to delete this proxy?",
    "notification.email_added": "Email added",
    "notification.email_deleted": "Email deleted",
    "confirm.delete_email.title": "Delete Email",
    "confirm.delete_email.description":
      "Are you sure you want to delete this email account?",
    "confirm.delete_file.title": "Delete File",
    "confirm.delete_file.description":
      "Are you sure you want to delete this file?",
    // Send email modal
    "send.to_email": "To Email",
    "send.select_file": "Select File",
    "send.subject_key": "Subject Key :",
    "send.subject_replace": "Subject Replace",
    "send.replace_key": "Replace Key :",
    "send.replace_value": "Replace Value",
    "send.input_string": "Input String",
    "send.check": "Check",
    "send.preview": "Preview",
    "send.cancel": "Cancel",
    "send.send": "Send",
    // Login page
    "login.title": "Login",
    "login.username": "Username",
    "login.password": "Password",
    "login.code": "Code",
    "login.get_code": "Get Code",
    "login.login": "LOGIN",
    "login.loading": "Loading...",
    "login.enter_username": "Please enter your username",
    "login.enter_password": "Please enter your password",
    "login.enter_code": "Please enter code",
    "login.code_sent": "Verification code has been sent",
    "login.code_failed": "Failed to get verification code",
    "login.success": "Login successful",
    "login.failed": "Login failed. Please try again",
    "header.logout": "Logout",
    // Navigation / Contact / Footer
    "nav.solutions": "Solutions",
    "nav.ecosystem": "Ecosystem",
    "nav.analytics": "Analytics",
    "nav.features": "Features",
    "nav.trust": "Trust",
    "nav.login": "Login",
    "nav.getStarted": "Get Started",
    "contact.title": "Contact Us",
    "contact.subtitle":
      "If you have any questions or suggestions, please feel free to contact us",
    "contact.email": "Email",
    "contact.phone": "Phone Number",
    "contact.additional": "Additional Info",
    "contact.emailPlaceholder": "Please enter your email",
    "contact.phonePlaceholder": "Please enter your phone number",
    "contact.additionalPlaceholder":
      "Please enter your requirements or suggestions",
    "contact.submit": "Send Message",
    "contact.success": "Submitted successfully! We will contact you soon.",
    "contact.error": "Submission failed, please try again later.",
    "footer.description":
      "Powering the world's payments with secure, reliable, and scalable infrastructure. Connecting businesses to customers globally.",
    "footer.privacyPolicy": "Privacy Policy",
    "footer.termsOfService": "Terms of Service",
    "footer.cookies": "Cookies",
    // Landing / Hero / Products / Sections
    "landing.hero.title1": "Smart, trusted",
    "landing.hero.title2": "payment solutions built for growth.",
    "landing.hero.description":
      "Accept payments, send payouts, and manage your finances with a single platform designed for high-growth businesses.",
    "landing.hero.startNow": "Start Now",
    "landing.hero.exploreProducts": "Explore Products",
    "landing.stats.transactions": "TRANSACTIONS / YEAR",
    "landing.stats.uptime": "UPTIME RELIABILITY",
    "landing.stats.currencies": "CURRENCIES SUPPORTED",
    "landing.stats.customers": "GLOBAL CUSTOMERS",
    "landing.solutions.subtitle": "OUR CORE SOLUTIONS",
    "landing.solutions.title": "Enterprise Email Infrastructure",
    "landing.solutions.description":
      "Scalable, reliable, and secure email solutions designed for high-volume delivery.",
    "landing.featured.gateway.title": "High-Performance SMTP",
    "landing.featured.gateway.desc":
      "Enterprise-grade SMTP infrastructure capable of handling millions of emails per hour with low latency and high reliability. Ensures your critical emails reach the inbox instantly.",
    "landing.featured.gateway.feat1": "High Throughput",
    "landing.featured.gateway.feat2": "Low Latency",
    "landing.featured.gateway.feat3": "99.9% Uptime",
    "landing.featured.invoice.title": "Real-time Analytics",
    "landing.featured.invoice.desc":
      "Gain deep insights into your email performance with real-time tracking of opens, clicks, bounces, and delivery rates. Make data-driven decisions to optimize your campaigns.",
    "landing.featured.invoice.feat1": "Live Tracking",
    "landing.featured.invoice.feat2": "Bounce Analysis",
    "landing.featured.invoice.feat3": "Visual Reports",
    "landing.featured.logistics.title": "Intelligent Delivery Engine",
    "landing.featured.logistics.desc":
      "Optimize inbox placement with our smart routing and IP reputation management. The system automatically handles retries, bounce processing, and ISP feedback loops.",
    "landing.featured.logistics.feat1": "Smart Routing",
    "landing.featured.logistics.feat2": "Auto-Retry Logic",
    "landing.featured.logistics.feat3": "Reputation Protection",
    "landing.featured.account.title": "Security & Compliance",
    "landing.featured.account.desc":
      "Protect your sender reputation and data with advanced security features including IP whitelisting, role-based access control, and TLS encryption for all data in transit.",
    "landing.featured.account.feat1": "IP Whitelisting",
    "landing.featured.account.feat2": "Role-Based Access",
    "landing.featured.account.feat3": "Data Encryption",
    "landing.ecosystem.subtitle": "OUR ECOSYSTEM",
    "landing.ecosystem.title1": "A complete suite for",
    "landing.ecosystem.title2": "every payment need",
    "landing.ecosystem.description":
      "Modular solutions that work together seamlessly. Choose what you need now and expand as you grow.",
    "landing.ecosystem.learnMore": "Learn more",
    "landing.analytics.badge": "ANALYTICS",
    "landing.analytics.title1": "Comprehensive analytics",
    "landing.analytics.title2": "and reporting",
    "landing.analytics.description":
      "Deep insights and dashboards to monitor performance and optimize operations.",
    "landing.analytics.feat1": "Real-time dashboards",
    "landing.analytics.feat2": "Custom reports",
    "landing.analytics.feat3": "Alerting & monitoring",
    "landing.analytics.feat4": "Transaction insights",
    "landing.analytics.explore": "Explore",
    "landing.features.subtitle": "FEATURES",
    "landing.features.title": "A complete suite of capabilities",
    "landing.features.description":
      "Powerful building blocks to run payments, risk, and reconciliation at scale.",
    "landing.features.grid.global.title": "Payment Gateway",
    "landing.features.grid.global.desc":
      "A powerful engine to accept payments online with high authorization rates.",
    "landing.features.grid.fraud.title": "Risk & Fraud",
    "landing.features.grid.fraud.desc":
      "Stop fraud before it happens with our AI-powered risk management suite.",
    "landing.features.grid.payouts.title": "Platform Connect",
    "landing.features.grid.payouts.desc":
      "The easiest way to integrate payments into your software platform or marketplace.",
    "landing.features.grid.analytics.title": "In-Person Payments",
    "landing.features.grid.analytics.desc":
      "Unified commerce solution for brick-and-mortar retailers.",
    "landing.features.grid.local.title": "Mobile SDK",
    "landing.features.grid.local.desc":
      "Native mobile experiences for iOS and Android apps.",
    "landing.features.grid.mobile.title": "Global Payouts",
    "landing.features.grid.mobile.desc":
      "Send money to sellers, freelancers, and suppliers worldwide.",
    "landing.trust.title": "Trusted by businesses worldwide",
    "landing.trust.item1": "Secure infrastructure",
    "landing.trust.item2": "High availability",
    "landing.trust.item3": "Global coverage",
    "landing.trust.item4": "Expert support",
    "landing.trust.transactions": "TRANSACTIONS",
    "landing.trust.volume": "VOLUME",
    "landing.cta.title": "Start scaling your payments",
    "landing.cta.description":
      "Join thousands of businesses that trust us with their payments. Set up your account in minutes.",
    "landing.cta.getStart": "Get Start",
    "landing.cta.contactSales": "Contact Sales",
    // Email system hero (EN)
    "email.hero.title1": "Smart, Reliable",
    "email.hero.title2": "email platform built for deliverability.",
    "email.hero.description":
      "Manage mailing lists, send transactional and marketing emails, and monitor deliverability with enterprise-grade tools.",
    "email.hero.getStarted": "Get Started",
    "email.hero.exploreFeatures": "Explore Features",
    // Landing - Products (EN)
    "landing.products.gateway.title": "Payment Gateway",
    "landing.products.gateway.desc":
      "A powerful engine to accept payments online with high authorization rates.",
    "landing.products.gateway.feat1": "Global acquiring",
    "landing.products.gateway.feat2": "Smart routing",
    "landing.products.gateway.feat3": "Recurring billing",
    "landing.products.risk.title": "Risk & Fraud",
    "landing.products.risk.desc":
      "Stop fraud before it happens with our AI-powered risk management suite.",
    "landing.products.risk.feat1": "3D Secure 2",
    "landing.products.risk.feat2": "Behavioral analysis",
    "landing.products.risk.feat3": "Custom rules",
    "landing.products.connect.title": "Platform Connect",
    "landing.products.connect.desc":
      "The easiest way to integrate payments into your software platform or marketplace.",
    "landing.products.connect.feat1": "Onboarding UI",
    "landing.products.connect.feat2": "Split payments",
    "landing.products.connect.feat3": "Compliance handling",
    "landing.products.terminal.title": "Terminal",
    "landing.products.terminal.desc":
      "Payments terminal and POS solutions for in-person commerce.",
    "landing.products.terminal.feat1": "EMV certified",
    "landing.products.terminal.feat2": "P2PE encryption",
    "landing.products.terminal.feat3": "Cloud management",
    "landing.products.mobile.title": "Mobile SDK",
    "landing.products.mobile.desc":
      "Native mobile experiences for iOS and Android apps.",
    "landing.products.mobile.feat1": "Apple Pay",
    "landing.products.mobile.feat2": "Google Pay",
    "landing.products.mobile.feat3": "One-tap checkout",
    "landing.products.payouts.title": "Global Payouts",
    "landing.products.payouts.desc":
      "Send money to sellers, freelancers, and suppliers worldwide.",
    "landing.products.payouts.feat1": "Instant transfers",
    "landing.products.payouts.feat2": "Multi-currency",
    "landing.products.payouts.feat3": "Low fees",
    // Email - Solutions (EN)
    "email.solutions.subtitle": "EMAIL PLATFORM",
    "email.solutions.title": "Powerful mailing and deliverability",
    "email.solutions.description":
      "Everything you need to send transactional and marketing emails with high deliverability and analytics.",
    "email.featured.deliverability.title": "High Deliverability",
    "email.featured.deliverability.desc":
      "Infrastructure and reputation tools to maximize inbox placement.",
    "email.featured.deliverability.feat1": "Dedicated IPs",
    "email.featured.deliverability.feat2": "Reputation monitoring",
    "email.featured.deliverability.feat3": "Automatic DKIM/SPF setup",
    "email.featured.campaigns.title": "Campaigns & Transactional",
    "email.featured.campaigns.desc":
      "Create, schedule, and send both marketing campaigns and transactional messages reliably.",
    "email.featured.campaigns.feat1": "A/B testing",
    "email.featured.campaigns.feat2": "Personalization",
    "email.featured.campaigns.feat3": "Transactional API",
    "email.featured.templates.title": "Templates & Automation",
    "email.featured.templates.desc":
      "Flexible templates and automation workflows for lifecycle messaging.",
    "email.featured.templates.feat1": "Drag & drop editor",
    "email.featured.templates.feat2": "Automatic workflows",
    "email.featured.templates.feat3": "Reusable snippets",
    "email.featured.insights.title": "Deliverability Insights",
    "email.featured.insights.desc":
      "Deep analytics to monitor opens, bounces, complaints, and engagement.",
    "email.featured.insights.feat1": "Realtime dashboards",
    "email.featured.insights.feat2": "Bounce analysis",
    "email.featured.insights.feat3": "Engagement cohorts",
    // Email - Products / Ecosystem (EN)
    "email.ecosystem.subtitle": "OUR ECOSYSTEM",
    "email.ecosystem.title1": "A complete suite for",
    "email.ecosystem.title2": "email sending needs",
    "email.ecosystem.description":
      "Modular email services that work together: transactional API, campaigns, templates, analytics and integrations.",
    "email.ecosystem.learnMore": "Learn more",
    "email.products.transactional.title": "Transactional API",
    "email.products.transactional.desc":
      "Reliable transactional email delivery with API and SMTP support.",
    "email.products.transactional.feat1": "REST API & SMTP",
    "email.products.transactional.feat2": "High throughput",
    "email.products.transactional.feat3": "Webhook events",
    "email.products.campaigns.title": "Campaigns",
    "email.products.campaigns.desc":
      "Create and send marketing campaigns with segmentation and A/B testing.",
    "email.products.campaigns.feat1": "Segmentation",
    "email.products.campaigns.feat2": "A/B testing",
    "email.products.campaigns.feat3": "Scheduling",
    "email.products.templates.title": "Templates & Builder",
    "email.products.templates.desc":
      "Visual template builder and reusable components for consistent messaging.",
    "email.products.templates.feat1": "Drag & drop editor",
    "email.products.templates.feat2": "Reusable components",
    "email.products.templates.feat3": "Versioning",
    "email.products.insights.title": "Analytics & Reporting",
    "email.products.insights.desc":
      "Delivery, engagement and bounce analytics to optimize campaigns.",
    "email.products.insights.feat1": "Open & click tracking",
    "email.products.insights.feat2": "Bounce reports",
    "email.products.insights.feat3": "Engagement cohorts",
    "email.products.sdk.title": "SDKs & Integrations",
    "email.products.sdk.desc":
      "Client SDKs and prebuilt integrations to connect your systems quickly.",
    "email.products.sdk.feat1": "JavaScript & Mobile SDKs",
    "email.products.sdk.feat2": "Prebuilt connectors",
    "email.products.sdk.feat3": "Webhook support",
    "email.products.integrations.title": "Integrations",
    "email.products.integrations.desc":
      "Connect with CRMs, e-commerce and analytics platforms.",
    "email.products.integrations.feat1": "CRM connectors",
    "email.products.integrations.feat2": "E-commerce plugins",
    "email.products.integrations.feat3": "BI integrations",
    // Hero Dashboard Mockup
    "hero.new_email": "New Email",
    "hero.to": "To",
    "hero.subject": "Subject",
    "hero.subject_placeholder": "Product Update Notification",
    "hero.content_preview": "Email content preview area...",
    "hero.attachment": "Attachment:",
    "hero.attachment_name": "report.pdf",
    "hero.send_success": "Sent Successfully",
    "hero.delivered": "Delivered to {n} recipient(s)",
    "hero.time_ago": "{n} minute(s) ago",
    "hero.new_mail": "New Email",
    // Conversational Commerce
    "commerce.sent_volume": "Email Sent Volume",
    "commerce.last_30_days": "Last 30 days",
    "commerce.template": "Template",
    "commerce.status": "Status",
    "commerce.open_rate": "Open Rate",
    "commerce.success_email": "Success Email",
    "commerce.sent": "Sent",
    // Cookie Policy
    "legal.cookiePolicy.title": "Cookie Policy",
    "legal.cookiePolicy.lastUpdated": "Last Updated: January 6, 2026",
    "legal.cookiePolicy.intro":
      "This is the Cookie Policy for Hsmail, accessible from https://www.hsmail.vip.",
    "legal.cookiePolicy.whatAreCookies.title": "What Are Cookies?",
    "legal.cookiePolicy.whatAreCookies.content":
      "As is common practice with almost all professional websites this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it and why we sometimes need to store these cookies.",
    "legal.cookiePolicy.howWeUse.title": "How We Use Cookies",
    "legal.cookiePolicy.howWeUse.content":
      "We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.",
    "legal.cookiePolicy.managing.title": "Managing Your Cookie Preferences",
    "legal.cookiePolicy.managing.content":
      "You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit.",
    // Privacy Policy
    "legal.privacyPolicy.title": "Privacy Policy",
    "legal.privacyPolicy.lastUpdated": "Last Updated: January 6, 2026",
    "legal.privacyPolicy.intro":
      "At Hsmail, accessible from https://www.hsmail.vip, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Hsmail and how we use it.",
    "legal.privacyPolicy.collection.title": "Information We Collect",
    "legal.privacyPolicy.collection.content":
      "We collect the following types of information:\n\n• Account Information: When you register for an account, we collect your email address, username, password, and contact information.\n\n• Email Content: We process emails you send and receive through our platform, including recipient addresses, subject lines, and message content for delivery purposes.\n\n• Usage Data: We collect information about your use of our services, including login times, features used, and interaction patterns.\n\n• Technical Data: IP address, browser type, operating system, and device information for service optimization and security.\n\n• Logs and Records: Sending logs, delivery status, bounce records, and communication history for service reliability.",
    "legal.privacyPolicy.usage.title": "How We Use Your Information",
    "legal.privacyPolicy.usage.content":
      "We use the collected information for the following purposes:\n\n• Service Delivery: To send, receive, and process your emails through our email infrastructure.\n\n• Account Management: To create and maintain your account, provide customer support, and communicate service updates.\n\n• Service Improvement: To analyze usage patterns, improve our platform's performance, and develop new features.\n\n• Security and Compliance: To protect against unauthorized access, fraud, and abuse, and to comply with legal obligations.\n\n• Analytics: To generate anonymous statistics about email delivery rates, open rates, and service performance.",
    "legal.privacyPolicy.sharing.title": "Sharing Information",
    "legal.privacyPolicy.sharing.content":
      "We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential.",
    "legal.privacyPolicy.security.title": "Security",
    "legal.privacyPolicy.security.content":
      "We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.",
    "legal.privacyPolicy.contact.title": "Contact Us",
    "legal.privacyPolicy.contact.content":
      "If you have any other questions about our privacy policy or need more information, please feel free to contact us at any time",
    // Terms of Service
    "legal.termsOfService.title": "Terms of Service",
    "legal.termsOfService.lastUpdated": "Last Updated: January 6, 2026",
    "legal.termsOfService.intro":
      "Welcome to Hsmail! These terms and conditions outline the rules and regulations for the use of Hsmail's Website, located at https://www.hsmail.vip.",
    "legal.termsOfService.acceptance.title": "Acceptance of Terms",
    "legal.termsOfService.acceptance.content":
      "By accessing this website we assume you accept these terms and conditions. Do not continue to use Hsmail if you do not agree to take all of the terms and conditions stated on this page.",
    "legal.termsOfService.services.title": "Description of Service",
    "legal.termsOfService.services.content":
      "Hsmail provides email sending and delivery services, including but not limited to transactional email delivery, marketing campaigns, email templates, and analytics. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time.",
    "legal.termsOfService.account.title": "User Account",
    "legal.termsOfService.account.content":
      "If you create an account on the Website, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password.",
    "legal.termsOfService.prohibited.title": "Prohibited Activities",
    "legal.termsOfService.prohibited.content":
      "You may not use the Site or Services for any purpose that is unlawful or prohibited by these Terms. You may not use the Services in violation of any laws in your jurisdiction (including but not limited to copyright laws).",
    "legal.termsOfService.termination.title": "Termination",
    "legal.termsOfService.termination.content":
      "We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.",
    "legal.termsOfService.liability.title": "Limitation of Liability",
    "legal.termsOfService.liability.content":
      "In no event shall Hsmail, nor any of its officers, directors, and employees, be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. Hsmail, including its officers, directors, and employees shall not be held liable for any indirect, consequential, or special liability arising out of or in any way related to your use of this Website.",
  },
  zh: {
    "footer.copyright": "版权所有 © 2025 Hsmail。保留所有权利。",
    "lang.chinese": "中文",
    "lang.english": "English",
    "sidebar.dashboard": "仪表盘",
    "sidebar.users": "用户",
    "sidebar.emails": "邮件",
    "sidebar.proxy": "代理",
    "sidebar.files": "文件",
    "sidebar.whitelist": "白名单",
    // Landing Page - Management Modules
    "email.dashboard.title": "仪表盘",
    "email.dashboard.desc": "数据概览与统计分析",
    "email.dashboard.feat1": "发送数据统计",
    "email.dashboard.feat2": "趋势图表展示",
    "email.dashboard.feat3": "实时监控数据",
    "email.emails.title": "邮件管理",
    "email.emails.desc": "邮件收发与列表管理",
    "email.emails.feat1": "邮件发送功能",
    "email.emails.feat2": "邮件列表查看",
    "email.emails.feat3": "邮件搜索过滤",
    "email.users.title": "用户管理",
    "email.users.desc": "系统用户与权限管理",
    "email.users.feat1": "用户账号管理",
    "email.users.feat2": "角色权限分配",
    "email.users.feat3": "用户行为记录",
    "email.proxy.title": "代理管理",
    "email.proxy.desc": "代理服务器配置与管理",
    "email.proxy.feat1": "代理服务器列表",
    "email.proxy.feat2": "IP隐藏与轮换",
    "email.proxy.feat3": "连接状态监控",
    "email.files.title": "模板管理",
    "email.files.desc": "邮件模板创建与管理",
    "email.files.feat1": "模板创建与编辑",
    "email.files.feat2": "模板预览与发送",
    "email.files.feat3": "模板状态控制",
    "email.whitelist.title": "白名单管理",
    "email.whitelist.desc": "可信任邮箱地址管理",
    "email.whitelist.feat1": "邮箱地址白名单",
    "email.whitelist.feat2": "域名白名单",
    "email.whitelist.feat3": "快速添加管理",
    "email.analytics.badge": "数据分析",
    "email.analytics.title1": "邮件数据统计",
    "email.analytics.title2": "可视化分析",
    "email.analytics.description":
      "实时监控邮件发送数据，了解投递状态与系统运行情况",
    "email.analytics.feat1": "邮件发送成功率统计",
    "email.analytics.feat2": "发送趋势图表展示",
    "email.analytics.feat3": "退信与失败分析",
    "email.analytics.feat4": "实时发送状态监控",
    "email.analytics.explore": "查看详情",
    // Features Section
    "email.features.subtitle": "核心功能",
    "email.features.title": "专业的邮件管理",
    "email.features.description":
      "一站式邮件管理解决方案，满足企业级邮件发送需求",
    "email.features.mail.title": "专业邮件发送",
    "email.features.mail.desc":
      "支持 SMTP/API 批量发送邮件，提供高效的邮件投递服务",
    "email.features.security.title": "安全可靠",
    "email.features.security.desc":
      "完善的用户权限体系和白名单机制，保障系统安全",
    "email.features.analytics.title": "数据分析",
    "email.features.analytics.desc":
      "实时统计邮件发送数据，可视化展示投递成功率和趋势",
    "email.features.users.title": "多用户管理",
    "email.features.users.desc":
      "支持管理员和普通用户角色，灵活分配操作权限",
    "email.features.files.title": "模板管理",
    "email.features.files.desc":
      "创建和管理邮件模板，支持预览和一键发送",
    "email.features.proxy.title": "代理支持",
    "email.features.proxy.desc":
      "灵活配置代理服务器，保护真实IP，提高发送成功率",
    "trend.title": "趋势",
    "legend.success": "成功",
    "legend.fail": "失败",
    "legend.total": "总计",
    "main.all_users": "所有用户",
    "summary.success": "成功",
    "summary.fail": "失败",
    "whitelist.add": "添加白名单",
    "whitelist.search_placeholder": "搜索",
    "whitelist.no_items": "暂无白名单",
    "whitelist.table.url": "站点",
    "whitelist.table.description": "描述",
    "whitelist.table.date": "日期",
    "whitelist.table.operation": "操作",
    "white.modal.add": "添加白名单",
    "white.modal.edit": "编辑白名单",
    "white.modal.url_label": "URL 或 地址",
    "white.modal.description_label": "描述",
    "white.modal.cancel": "取消",
    "white.modal.save": "保存",
    "white.modal.url_required": "必须填写 URL 或 地址",
    "pagination.go_to": "跳转到",
    "pagination.go": "确定",
    "pagination.per_page": "{n} / 页",
    "confirm.delete_whitelist.title": "删除白名单",
    "confirm.delete_whitelist.description": "确定要删除该白名单项吗？",
    "confirm.delete": "删除",
    "confirm.cancel": "取消",
    "notification.whitelist_added": "白名单已添加",
    "notification.whitelist_updated": "白名单已更新",
    "notification.whitelist_deleted": "白名单已删除",
    "notification.failed_save": "保存白名单失败",
    "notification.failed_delete": "删除白名单失败",
    "status.on": "开启",
    "status.off": "关闭",
    // Users
    "users.add": "添加用户",
    "users.search_placeholder": "搜索",
    "users.no_items": "暂无联系人",
    "users.role.user": "用户",
    "users.role.admin": "管理员",
    "users.table.account": "账户",
    "users.table.password": "密码",
    "users.table.nickname": "昵称",
    "users.table.role": "角色",
    "users.table.operation": "操作",
    "confirm.delete_user.title": "删除用户",
    "confirm.delete_user.description": "确定要删除用户“{name}”吗？",
    "notification.user_deleted": "用户已删除",
    "notification.failed_delete_user": "删除用户失败",
    "user.modal.add": "添加用户",
    "user.modal.save": "保存",
    "user.modal.cancel": "取消",
    "user.modal.account_required": "必须填写账户",
    "user.modal.password_required": "必须填写密码",
    // Files
    "files.search_placeholder": "按名称搜索",
    "files.add": "添加文件",
    "files.no_items": "暂无文件",
    "files.table.filename": "文件名",
    "files.table.status": "状态",
    "files.table.date": "日期",
    "files.table.operation": "操作",
    "file.modal.add": "添加文件",
    "file.modal.edit": "编辑文件",
    "file.modal.preview": "预览",
    "file.modal.filename_label": "文件名",
    "file.modal.title_label": "文件标题",
    "file.modal.status_label": "状态",
    "notification.file_added": "文件已添加",
    "notification.file_updated": "文件已更新",
    "notification.file_deleted": "文件已删除",
    "files.table.file_key": "文件密钥",
    "files.table.key": "密钥",
    "files.table.content": "文本",
    // Proxy
    "proxy.search_placeholder": "按 Host 搜索",
    "proxy.add_one": "添加代理",
    "proxy.add_one_desc": "添加单个代理",
    "proxy.add": "添加代理",
    "proxy.add_many_desc": "一次添加多个代理，按行粘贴 CSV",
    "proxy.no_items": "暂无代理",
    "proxy.table.host": "主机/服务器",
    "proxy.table.port": "端口",
    "proxy.table.account": "账号",
    "proxy.table.password": "密码",
    "proxy.table.type": "类型",
    "proxy.table.status": "状态",
    "proxy.table.date": "日期",
    "proxy.table.operation": "操作",
    "proxy.modal.add": "添加代理",
    "proxy.modal.edit": "编辑代理",
    "notification.proxy_added": "代理已添加",
    "notification.proxy_deleted": "代理已删除",
    "notification.proxy_delete_failed": "删除代理失败",
    "confirm.delete_proxy": "删除代理",
    "confirm.delete_proxy.description": "确定要删除该代理吗？",
    "proxy.bulk.title": "批量添加代理",
    "proxy.bulk.format_hint": "(主机,端口,账号,密码,SOCKS5)",
    // Emails
    "emails.add": "添加邮件",
    "emails.add_one": "添加邮件",
    "emails.add_one_desc": "添加单个邮件",
    "emails.add_many": "添加多个邮件",
    "emails.add_many_desc": "一次添加多个邮件，按行粘贴 CSV",
    "emails.bulk.title": "批量添加邮件",
    "emails.bulk.format_hint":
      "(账号,密码,密钥,端口,SMTP,地址 | 主机,端口,账号,密码,SOCKS5)",
    "emails.bulk.instructions": "每行输入一条 CSV",
    "emails.adding": "添加中...",
    "emails.search_placeholder": "搜索",
    // Filters (used in Main.js)
    filters: "筛选",
    "filter.start_time": "开始时间",
    "filter.end_time": "结束时间",
    "filter.order_user": "订单用户",
    "filter.all": "全部",
    "emails.no_items": "暂无邮件",
    "emails.table.mail_user": "邮件账户",
    "emails.table.ip": "IP地址",
    "emails.table.mail_key": "邮箱密钥",
    "emails.table.mail_password": "邮件密码",
    "emails.table.port": "端口",
    "emails.table.smtp_server": "SMTP 服务器",
    "emails.table.status": "状态",
    "emails.table.date": "日期",
    "emails.table.operation": "操作",
    "email.modal.add": "添加邮件",
    "email.modal.edit": "编辑邮件",
    "notification.email_added": "邮件已添加",
    "notification.email_deleted": "邮件已删除",
    "notification.failed_delete_email": "删除邮件失败",
    "confirm.delete_email.title": "删除邮件",
    "confirm.delete_email.description": "确定要删除该邮箱账户吗？",
    "confirm.delete_file.title": "删除文件",
    "confirm.delete_file.description": "确定要删除该文件吗？",
    // Send email modal
    "send.to_email": "邮件接收者",
    "send.select_file": "选择文件模版",
    "send.subject_key": "主题关键词:",
    "send.subject_replace": "主题替换",
    "send.replace_key": "替换关键词:",
    "send.replace_value": "替换值",
    "send.input_string": "检测字符串",
    "send.check": "检测",
    "send.preview": "预览",
    "send.cancel": "取消",
    "send.send": "发送",
    // Login page
    "login.title": "登录",
    "login.username": "用户名",
    "login.password": "密码",
    "login.code": "验证码",
    "login.get_code": "获取验证码",
    "login.login": "登录",
    "login.loading": "加载中...",
    "login.enter_username": "请输入用户名",
    "login.enter_password": "请输入密码",
    "login.enter_code": "请输入验证码",
    "login.code_sent": "验证码已发送",
    "login.code_failed": "获取验证码失败",
    "login.success": "登录成功",
    "login.failed": "登录失败，请重试",
    "header.logout": "退出登录",
    // Navigation / Contact / Footer
    "nav.solutions": "解决方案",
    "nav.ecosystem": "生态系统",
    "nav.analytics": "数据分析",
    "nav.features": "功能特性",
    "nav.trust": "信任保障",
    "nav.login": "登录",
    "nav.getStarted": "立即开始",
    "contact.title": "联系我们",
    "contact.subtitle": "如果您有任何问题或建议，请随时与我们联系",
    "contact.email": "电子邮箱",
    "contact.phone": "电话号码",
    "contact.additional": "附加信息",
    "contact.emailPlaceholder": "请输入您的邮箱",
    "contact.phonePlaceholder": "请输入您的电话",
    "contact.additionalPlaceholder": "请输入您的需求或建议",
    "contact.submit": "发送消息",
    "contact.success": "提交成功！我们会尽快与您联系。",
    "contact.error": "提交失败，请稍后重试。",
    "footer.description":
      "致力于构建安全、可靠、可扩展的全球支付基础设施，连接全球企业与消费者。",
    "footer.privacyPolicy": "隐私政策",
    "footer.termsOfService": "服务条款",
    "footer.cookies": "Cookie 政策",
    // Landing / Hero / Products / Sections (中文)
    "landing.hero.title1": "智能、可信赖的",
    "landing.hero.title2": "支付解决方案，助力成长。",
    "landing.hero.description":
      "一站式平台，支持收款、付款与资金管理，专为高增长企业设计。",
    "landing.hero.startNow": "开始使用",
    "landing.hero.exploreProducts": "探索产品",
    "landing.stats.transactions": "交易量 / 年",
    "landing.stats.uptime": "可用性",
    "landing.stats.currencies": "支持货币",
    "landing.stats.customers": "全球客户",
    "landing.solutions.subtitle": "核心解决方案",
    "landing.solutions.title": "企业级邮件基础设施",
    "landing.solutions.description":
      "专为大规模投递设计的可扩展、可靠且安全的邮件解决方案。",
    "landing.featured.gateway.title": "高性能 SMTP",
    "landing.featured.gateway.desc":
      "企业级 SMTP 基础设施，每小时处理数百万封邮件，具有低延迟和高可靠性。确保您的关键邮件即时到达收件箱。",
    "landing.featured.gateway.feat1": "高吞吐量",
    "landing.featured.gateway.feat2": "低延迟",
    "landing.featured.gateway.feat3": "99.9% 在线率",
    "landing.featured.invoice.title": "实时数据分析",
    "landing.featured.invoice.desc":
      "通过实时跟踪打开、点击、退信和送达率，深入了解您的邮件表现。利用数据驱动决策优化您的营销活动。",
    "landing.featured.invoice.feat1": "实时追踪",
    "landing.featured.invoice.feat2": "退信分析",
    "landing.featured.invoice.feat3": "可视化报表",
    "landing.featured.logistics.title": "智能投递引擎",
    "landing.featured.logistics.desc":
      "通过智能路由和 IP 声誉管理优化收件箱到达率。系统自动处理重试、退信处理和 ISP 反馈循环。",
    "landing.featured.logistics.feat1": "智能路由",
    "landing.featured.logistics.feat2": "自动重试机制",
    "landing.featured.logistics.feat3": "声誉保护",
    "landing.featured.account.title": "安全与合规",
    "landing.featured.account.desc":
      "通过 IP 白名单、基于角色的访问控制和全链路 TLS 加密等高级安全功能，保护您的发件人声誉和数据。",
    "landing.featured.account.feat1": "IP 白名单",
    "landing.featured.account.feat2": "角色权限管理",
    "landing.featured.account.feat3": "数据加密",
    "landing.ecosystem.subtitle": "我们的生态系统",
    "landing.ecosystem.title1": "面向每一种",
    "landing.ecosystem.title2": "支付需求的完整套件",
    "landing.ecosystem.description":
      "模块化解决方案无缝协同。按需选择并随业务增长扩展。",
    "landing.ecosystem.learnMore": "了解更多",
    "landing.analytics.badge": "分析与报告",
    "landing.analytics.title1": "全面的分析",
    "landing.analytics.title2": "与报表",
    "landing.analytics.description":
      "深入的洞察与仪表盘，帮助你监控表现与优化运营。",
    "landing.analytics.feat1": "实时仪表盘",
    "landing.analytics.feat2": "自定义报表",
    "landing.analytics.feat3": "告警与监控",
    "landing.analytics.feat4": "交易洞察",
    "landing.analytics.explore": "查看",
    "landing.features.subtitle": "功能特性",
    "landing.features.title": "完整的能力套件",
    "landing.features.description":
      "强大的构建模块，帮助规模化运行支付、风控和对账。",
    "landing.features.grid.global.title": "支付网关",
    "landing.features.grid.global.desc":
      "强大的引擎，在线接受支付并提供高授权率。",
    "landing.features.grid.fraud.title": "风控与反欺诈",
    "landing.features.grid.fraud.desc":
      "借助 AI 风控套件在欺诈发生前阻止风险。",
    "landing.features.grid.payouts.title": "平台连接",
    "landing.features.grid.payouts.desc":
      "将支付集成到你的软件平台或市场的最简单方式。",
    "landing.features.grid.analytics.title": "线下收单",
    "landing.features.grid.analytics.desc": "面向实体零售的统一收单解决方案。",
    "landing.features.grid.local.title": "移动 SDK",
    "landing.features.grid.local.desc": "用于 iOS 与 Android 的原生移动体验。",
    "landing.features.grid.mobile.title": "全球支付/出款",
    "landing.features.grid.mobile.desc":
      "向卖家、自由职业者与供应商全球发放款项。",
    "landing.trust.title": "受到全球企业信赖",
    "landing.trust.item1": "安全的基础设施",
    "landing.trust.item2": "高可用性",
    "landing.trust.item3": "全球覆盖",
    "landing.trust.item4": "专家支持",
    "landing.trust.transactions": "交易量",
    "landing.trust.volume": "交易额",
    "landing.cta.title": "开始扩展你的支付能力",
    "landing.cta.description":
      "加入成千上万信任我们支付服务的企业。几分钟内即可设置您的账户。",
    "landing.cta.getStart": "立即开始",
    "landing.cta.contactSales": "联系销售",
    // Email system hero (ZH)
    "email.hero.title1": "智能、可靠的",
    "email.hero.title2": "邮件平台，助力高送达率。",
    "email.hero.description":
      "管理邮件列表，发送事务与营销邮件，并使用企业级工具监控投递与送达情况。",
    "email.hero.getStarted": "立即开始",
    "email.hero.exploreFeatures": "探索功能",
    // Landing - Products (ZH)
    "landing.products.gateway.title": "支付网关",
    "landing.products.gateway.desc":
      "强大的在线支付引擎，提供极高的授权成功率。",
    "landing.products.gateway.feat1": "全球收单",
    "landing.products.gateway.feat2": "智能路由",
    "landing.products.gateway.feat3": "循环计费",
    "landing.products.risk.title": "风险与欺诈",
    "landing.products.risk.desc":
      "利用 AI 驱动的风控套件，在欺诈发生前阻止风险。",
    "landing.products.risk.feat1": "3D 安全验证 2.0",
    "landing.products.risk.feat2": "行为分析",
    "landing.products.risk.feat3": "自定义规则",
    "landing.products.connect.title": "平台连接",
    "landing.products.connect.desc":
      "将支付功能集成到您的软件平台或市场的最简单方式。",
    "landing.products.connect.feat1": "入驻界面",
    "landing.products.connect.feat2": "分账支付",
    "landing.products.connect.feat3": "合规处理",
    "landing.products.terminal.title": "终端",
    "landing.products.terminal.desc": "面向线下场景的支付终端与 POS 解决方案。",
    "landing.products.terminal.feat1": "EMV 认证",
    "landing.products.terminal.feat2": "P2PE 加密",
    "landing.products.terminal.feat3": "云端管理",
    "landing.products.mobile.title": "移动 SDK",
    "landing.products.mobile.desc": "为 iOS 与 Android 应用提供原生移动体验。",
    "landing.products.mobile.feat1": "Apple Pay",
    "landing.products.mobile.feat2": "Google Pay",
    "landing.products.mobile.feat3": "一键结账",
    "landing.products.payouts.title": "全球代付",
    "landing.products.payouts.desc": "向全球卖家、自由职业者与供应商发放款项。",
    "landing.products.payouts.feat1": "即时转账",
    "landing.products.payouts.feat2": "多币种支持",
    "landing.products.payouts.feat3": "低费率",
    // Email - Solutions (ZH)
    "email.solutions.subtitle": "邮件平台",
    "email.solutions.title": "强大的邮件发送与投递能力",
    "email.solutions.description":
      "提供事务与营销邮件发送、送达能力与分析的一站式解决方案。",
    "email.featured.deliverability.title": "高送达率",
    "email.featured.deliverability.desc":
      "基础设施与声誉工具，最大化到达收件箱的能力。",
    "email.featured.deliverability.feat1": "独立 IP",
    "email.featured.deliverability.feat2": "声誉监控",
    "email.featured.deliverability.feat3": "自动 DKIM/SPF 配置",
    "email.featured.campaigns.title": "活动与事务邮件",
    "email.featured.campaigns.desc":
      "可靠地创建、调度并发送营销活动与事务性消息。",
    "email.featured.campaigns.feat1": "A/B 测试",
    "email.featured.campaigns.feat2": "个性化内容",
    "email.featured.campaigns.feat3": "事务 API",
    "email.featured.templates.title": "模板与自动化",
    "email.featured.templates.desc":
      "灵活的模板与自动化工作流，支持生命周期消息。",
    "email.featured.templates.feat1": "可视化编辑器",
    "email.featured.templates.feat2": "自动化工作流",
    "email.featured.templates.feat3": "可复用片段",
    "email.featured.insights.title": "投递分析",
    "email.featured.insights.desc": "深入分析打开、退信、投诉与用户参与数据。",
    "email.featured.insights.feat1": "实时仪表盘",
    "email.featured.insights.feat2": "退信分析",
    "email.featured.insights.feat3": "用户参与细分",
    // Email - Products / Ecosystem (ZH)
    "email.ecosystem.subtitle": "我们的生态系统",
    "email.ecosystem.title1": "面向",
    "email.ecosystem.title2": "邮件发送需求的完整套件",
    "email.ecosystem.description":
      "模块化的邮件服务协同工作：事务 API、活动、模板、分析与集成。",
    "email.ecosystem.learnMore": "了解更多",
    "email.products.transactional.title": "事务 API",
    "email.products.transactional.desc":
      "可靠的事务邮件投递，支持 API 与 SMTP。",
    "email.products.transactional.feat1": "REST API 与 SMTP",
    "email.products.transactional.feat2": "高吞吐量",
    "email.products.transactional.feat3": "Webhook 事件",
    "email.products.campaigns.title": "营销活动",
    "email.products.campaigns.desc":
      "创建并发送营销活动，支持分段与 A/B 测试。",
    "email.products.campaigns.feat1": "用户分群",
    "email.products.campaigns.feat2": "A/B 测试",
    "email.products.campaigns.feat3": "定时发送",
    "email.products.templates.title": "模板与编辑器",
    "email.products.templates.desc":
      "可视化模板编辑器与可复用组件，保证一致的消息样式。",
    "email.products.templates.feat1": "拖放式编辑器",
    "email.products.templates.feat2": "可复用组件",
    "email.products.templates.feat3": "版本管理",
    "email.products.insights.title": "分析与报告",
    "email.products.insights.desc": "投递、参与与退信分析，帮助优化活动表现。",
    "email.products.insights.feat1": "打开与点击跟踪",
    "email.products.insights.feat2": "退信报告",
    "email.products.insights.feat3": "用户参与分群",
    "email.products.sdk.title": "SDK 与集成",
    "email.products.sdk.desc": "客户端 SDK 与预构建集成，快速连接你的系统。",
    "email.products.sdk.feat1": "JavaScript 与移动 SDK",
    "email.products.sdk.feat2": "预构建连接器",
    "email.products.sdk.feat3": "Webhook 支持",
    "email.products.integrations.title": "集成",
    "email.products.integrations.desc": "与 CRM、电商与分析平台无缝对接。",
    "email.products.integrations.feat1": "CRM 连接器",
    "email.products.integrations.feat2": "电商插件",
    "email.products.integrations.feat3": "BI 集成",
    "email.modal.mail_user_required": "必须填写邮箱账户",
    "email.modal.mail_password_required": "必须填写邮箱密码",
    "email.modal.smtp_required": "必须填写 SMTP Server",
    "email.modal.port_required": "必须填写端口",
    "email.modal.port_number": "端口必须为数字",
    // Hero Dashboard Mockup
    "hero.new_email": "新建邮件",
    "hero.to": "收件人",
    "hero.subject": "主题",
    "hero.subject_placeholder": "产品更新通知",
    "hero.content_preview": "邮件内容预览区域...",
    "hero.attachment": "附件:",
    "hero.attachment_name": "report.pdf",
    "hero.send_success": "发送成功",
    "hero.delivered": "已送达至 {n} 位收件人",
    "hero.time_ago": "{n}分钟前",
    "hero.new_mail": "新邮件",
    // Conversational Commerce
    "commerce.sent_volume": "邮件发送量",
    "commerce.last_30_days": "最近30天",
    "commerce.template": "模版",
    "commerce.status": "状态",
    "commerce.open_rate": "打开率",
    "commerce.success_email": "成功邮件",
    "commerce.sent": "已发送",
    // Cookie Policy
    "legal.cookiePolicy.title": "Cookie 政策",
    "legal.cookiePolicy.lastUpdated": "最后更新：2026年1月6日",
    "legal.cookiePolicy.intro":
      "这是 Hsmail 的 Cookie 政策，可通过 https://www.hsmail.vip 访问。",
    "legal.cookiePolicy.whatAreCookies.title": "什么是 Cookies？",
    "legal.cookiePolicy.whatAreCookies.content":
      "正如几乎所有专业网站的惯例一样，本网站使用 Cookie，这还是下载到您计算机上的微小文件，以改善您的体验。本页面描述了我们收集哪些信息、我们如何使用这些信息以及为什么我们有时需要存储这些 Cookie。",
    "legal.cookiePolicy.howWeUse.title": "我们如何使用 Cookies",
    "legal.cookiePolicy.howWeUse.content":
      "我们将 Cookie 用于多种原因。不幸的是，在大多数情况下，没有行业标准选项可以在不完全禁用 Cookie 添加到本网站的功能和特性的情况下禁用 Cookie。如果您不确定是否需要它们，建议您保留所有 Cookie。",
    "legal.cookiePolicy.managing.title": "管理您的 Cookie 偏好",
    "legal.cookiePolicy.managing.content":
      "您可以通过调整浏览器上的设置来阻止设置 Cookie（请参阅浏览器帮助了解如何操作）。请注意，禁用 Cookie 将影响本网站和您访问的许多其他网站的功能。",
    // Privacy Policy
    "legal.privacyPolicy.title": "隐私政策",
    "legal.privacyPolicy.lastUpdated": "最后更新：2026年1月6日",
    "legal.privacyPolicy.intro":
      "在 Hsmail（可通过 https://www.hsmail.vip 访问），我们的主要任务之一是保护访客的隐私。本隐私政策文件包含 Hsmail 收集和记录的信息类型以及我们如何使用这些信息。",
    "legal.privacyPolicy.collection.title": "我们要收集的信息",
    "legal.privacyPolicy.collection.content":
      "我们收集以下类型的信息：\n\n• 账户信息：注册账户时，我们收集您的邮箱地址、用户名、密码和联系信息。\n\n• 邮件内容：我们处理您通过我们的平台发送和接收的电子邮件，包括收件人地址、主题行和邮件内容，仅用于投递目的。\n\n• 使用数据：我们收集您使用我们服务的信息，包括登录时间、使用功能和交互模式。\n\n• 技术数据：IP 地址、浏览器类型、操作系统和设备信息，用于服务优化和安全。\n\n• 日志和记录：发送日志、投递状态、退信记录和通信历史，用于服务可靠性保障。",
    "legal.privacyPolicy.usage.title": "我们如何使用您的信息",
    "legal.privacyPolicy.usage.content":
      "我们将收集的信息用于以下目的：\n\n• 服务投递：通过我们的邮件基础设施发送、接收和处理您的电子邮件。\n\n• 账户管理：创建和维护您的账户，提供客户服务，并沟通服务更新。\n\n• 服务改进：分析使用模式，改善我们平台的性能，并开发新功能。\n\n• 安全与合规：防止未经授权的访问、欺诈和滥用，并遵守法律义务。\n\n• 分析：生成关于邮件投递率、打开率和服务性能的匿名统计数据。",
    "legal.privacyPolicy.sharing.title": "信息共享",
    "legal.privacyPolicy.sharing.content":
      "我们不会出售、交易或以其他方式将您的个人身份信息转让给外部方。但这不包括协助我们运营网站、开展业务或为您提供服务的受信任的第三方，前提是这些方同意对这些信息保密。",
    "legal.privacyPolicy.security.title": "安全",
    "legal.privacyPolicy.security.content":
      "我们采取适当的安全措施来防止未经授权的访问、更改、披露或销毁您的个人信息、用户名、密码、交易信息和存储在我们网站上的数据",
    "legal.privacyPolicy.contact.title": "联系我们",
    "legal.privacyPolicy.contact.content":
      "如果您对我们的隐私政策有其他疑问或需要更多信息，请随时联系我们",
    // Terms of Service
    "legal.termsOfService.title": "服务条款",
    "legal.termsOfService.lastUpdated": "最后更新：2026年1月6日",
    "legal.termsOfService.intro":
      "欢迎使用 Hsmail！这些条款和条件概述了使用位于 https://www.hsmail.vip 的 Hsmail 网站的规则和条例。",
    "legal.termsOfService.acceptance.title": "接受条款",
    "legal.termsOfService.acceptance.content":
      "访问本网站，即表示您接受这些条款和条件。如果您不同意本页面上所述的所有条款和条件，请勿继续使用 Hsmail",
    "legal.termsOfService.services.title": "服务",
    "legal.termsOfService.services.content":
      "Hsmail 提供电子邮件发送与投递服务，包括但不限于事务性邮件投递、营销活动邮件、邮件模板以及数据分析功能。我们保留在任何时间修改、暂停或终止服务任何部分的权利",
    "legal.termsOfService.account.title": "用户账户",
    "legal.termsOfService.account.content":
      "如果您在本网站创建账户，您有责任维护您的账户和密码的机密性，并限制对您计算机的访问，并且您同意对在您的账户或密码下发生的所有活动承担责任。",
    "legal.termsOfService.prohibited.title": "禁止活动",
    "legal.termsOfService.prohibited.content":
      "您不得使用本网站或服务进行任何非法或未经授权的目的。在使用服务时，您不得违反您所在司法管辖区的任何法律（包括但不限于版权法）。",
    "legal.termsOfService.termination.title": "终止",
    "legal.termsOfService.termination.content":
      "我们可以出于任何原因（包括但不限于违反条款）立即终止或暂停您的账户，恕不另行通知或承担责任。",
    "legal.termsOfService.liability.title": "责任限制",
    "legal.termsOfService.liability.content":
      "在任何情况下，Hsmail 或其供应商均不对因使用或无法使用 Hsmail 网站上的材料而造成的任何损害（包括但不限于数据丢失或利润损失，或由于业务中断而造成的损害）负责。",
  },
};

export const LocaleProvider = ({
  children,
  defaultLocale = "zh",
  translations,
}) => {
  const detectBrowserLocale = () => {
    try {
      if (typeof navigator === "undefined") return null;
      const navLang =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        navigator.userLanguage ||
        null;
      if (!navLang) return null;
      // map zh* -> zh, everything else -> en
      return navLang.toLowerCase().startsWith("zh") ? "zh" : "en";
    } catch (e) {
      return null;
    }
  };

  const initialLocale =
    typeof window !== "undefined"
      ? localStorage.getItem("locale") || detectBrowserLocale() || defaultLocale
      : defaultLocale;
  const [locale, setLocaleState] = useState(initialLocale);
  const merged = { ...defaultTranslations, ...(translations || {}) };

  // persist and apply HTML lang attribute so native date pickers use correct locale
  useEffect(() => {
    try {
      localStorage.setItem("locale", locale);
    } catch (e) {
      // ignore
    }
    const htmlLang = locale === "zh" ? "zh-CN" : "en-US";
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", htmlLang);
    }
  }, [locale]);

  const setLocale = (next) => {
    setLocaleState(next);
  };

  const t = (key, vars) => {
    const dict = merged[locale] || {};
    let v = dict[key] ?? key;
    if (vars && typeof v === "string") {
      Object.keys(vars).forEach((k) => {
        v = v.replace(`{${k}}`, String(vars[k]));
      });
    }
    return v;
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useTranslation = () => {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    return {
      t: (k) => k,
      locale: "zh",
      setLocale: () => { },
    };
  }
  return { t: ctx.t, locale: ctx.locale, setLocale: ctx.setLocale };
};

export default LocaleContext;
